import React from 'react';
import PropTypes from 'prop-types';

import { charCounterTier } from '../../utils/seoFieldStatus';

/*
Character count for a field that search engines truncate. Green while the text
fits, amber once it is past the recommended length, red once the tail is
certain to be cut. Light shades: these sit on the dark form panel.
*/
const COLOR_BY_TIER = {
  ok: 'text-green-light',
  warn: 'text-orange-light',
  over: 'text-red-light',
};

const CharCounter = ({ value, limits }) => {
  const { length } = value || '';
  const tier = charCounterTier(length, limits);

  return (
    <span className={`font-americaMonoRegular text-xs normal-case ${COLOR_BY_TIER[tier]}`}>
      {`${length} / ${limits.warn}`}
      {tier === 'over' && ' — will be truncated'}
    </span>
  );
};

CharCounter.propTypes = {
  value: PropTypes.string,
  limits: PropTypes.shape({
    warn: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
  }).isRequired,
};

CharCounter.defaultProps = {
  value: '',
};

export default CharCounter;
